import {
  TRIGGER_WEBHOOK,
  TRIGGER_WEBHOOK_SUCCESS,
  TRIGGER_WEBHOOK_ERROR,
  GET_SITE_VISIT_STATUS_DATA,
  UPDATE_SITE_VISIT_STATUS,
} from "../types";

const initialState = {
  webhookLoading: false,
  webhookSuccess: false,
  webhookError: null,
  webhookResponse: null,
  statusData: null,
  updateStatusResponse: null,
};

const siteVisitReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_WEBHOOK:
      return {
        ...state,
        webhookLoading: true,
        webhookSuccess: false,
        webhookError: null,
      };

    case TRIGGER_WEBHOOK_SUCCESS:
      return {
        ...state,
        webhookLoading: false,
        webhookSuccess: true,
        webhookError: null,
        webhookResponse: action.payload,
      };

    case TRIGGER_WEBHOOK_ERROR:
      return {
        ...state,
        webhookLoading: false,
        webhookSuccess: false,
        webhookError: action.payload,
        webhookResponse: null,
      };

    case GET_SITE_VISIT_STATUS_DATA:
      return {
        ...state,
        statusData: action.payload,
      };

    case UPDATE_SITE_VISIT_STATUS:
      return {
        ...state,
        updateStatusResponse: action.payload,
      };

    default:
      return state;
  }
};

export default siteVisitReducer;

